(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[67127,44725,93509,22432,94596,44243,93375,22456,95660],{

/***/ 97943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Facebook() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "35",
        fill: "none",
        viewBox: "0 0 69 35",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "69",
                height: "35",
                fill: "#4780c0",
                rx: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_32_1514",
                style: {
                    maskType: "alpha"
                },
                width: "18",
                height: "15",
                x: "26",
                y: "10",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M26.121 10H43.208V25H26.121z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                mask: "url(#mask0_32_1514)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M33.155 24.318h3.04v-6.881h2.12l.232-2.301h-2.353v-1.31c0-.548.116-.756.7-.756h1.653v-2.388h-2.115c-2.268 0-3.289.898-3.289 2.618v1.841h-1.586v2.329h1.586l.012 6.848z"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Facebook);


/***/ }),

/***/ 22371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Twitter() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "35",
        fill: "none",
        viewBox: "0 0 69 35",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "69",
                height: "35",
                fill: "#35a9ff",
                rx: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                style: {
                    maskType: "alpha"
                },
                width: "18",
                height: "15",
                x: "26",
                y: "10",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M26.025 10H43.111999999999995V25H26.025z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_32_1513)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M26.01 22.15a10.97 10.97 0 005.135 1.374 11.06 11.06 0 005.201-1.167c1.58-.8 2.878-1.965 3.755-3.369.877-1.403 1.298-2.99 1.217-4.59a6.803 6.803 0 001.779-1.595 7.52 7.52 0 01-2.012.484c.736-.38 1.289-.984 1.553-1.697a7.756 7.756 0 01-2.22.75 3.665 3.665 0 00-1.983-.933c-.76-.111-1.54.002-2.22.32-.68.32-1.22.826-1.537 1.442a2.725 2.725 0 00-.218 1.966 11.02 11.02 0 01-3.997-.927 9.796 9.796 0 01-3.218-2.277 2.746 2.746 0 00-.38 2.234c.203.76.727 1.424 1.467 1.856a3.872 3.872 0 01-1.553-.381c-.01.715.265 1.41.777 1.966s1.228.939 2.026 1.081a4.064 4.064 0 01-1.553.055 3.1 3.1 0 001.24 1.525 3.804 3.804 0 002.022.602 7.394 7.394 0 01-2.492 1.114 7.931 7.931 0 01-2.79.168z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_32_1513",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H17.048V12.164H0z",
                        transform: "translate(26.025 11.364)"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Twitter);


/***/ }),

/***/ 43808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Pinterest() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "35",
        fill: "none",
        viewBox: "0 0 69 35",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "69",
                height: "35",
                fill: "#e60023",
                rx: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_32_1516",
                style: {
                    maskType: "alpha"
                },
                width: "19",
                height: "15",
                x: "25",
                y: "10",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M25.93 10H43.016999999999996V25H25.93z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                mask: "url(#mask0_32_1516)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M30.756 18.573a.327.327 0 00.382-.078.262.262 0 00.056-.117c.037-.14.129-.486.172-.631.043-.145.037-.263-.123-.436a2.15 2.15 0 01-.573-1.541c-.007-.505.1-1.005.314-1.47.214-.466.53-.887.929-1.239a4.177 4.177 0 011.392-.806 4.492 4.492 0 011.631-.244c2.33 0 3.607 1.29 3.607 3.01 0 2.262-1.104 4.172-2.75 4.172a1.46 1.46 0 01-.613-.103 1.331 1.331 0 01-.494-.343 1.168 1.168 0 01-.27-.509 1.1 1.1 0 01.014-.564c.26-.994.765-2.066.765-2.792.02-.15.005-.3-.045-.444a1.03 1.03 0 00-.244-.388 1.162 1.162 0 00-.4-.26 1.265 1.265 0 00-.483-.087c-.924 0-1.67.866-1.67 2.028-.006.428.088.853.277 1.245l-1.116 4.273a8.05 8.05 0 000 2.982c.004.02.014.038.03.053a.12.12 0 00.055.03.13.13 0 00.064 0 .12.12 0 00.055-.032 8.308 8.308 0 001.566-2.57c.104-.351.616-2.161.616-2.161.233.312.549.566.918.738.37.171.782.256 1.197.245 2.787 0 4.673-2.301 4.673-5.384 0-2.324-2.176-4.468-5.48-4.468-4.12 0-6.166 2.675-6.166 4.903-.056 1.34.505 2.542 1.714 2.988z"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Pinterest);


/***/ }),

/***/ 8281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Mobile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/oneElement/index.tsx
var oneElement = __webpack_require__(36895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/share/styles.module.scss
var styles_module = __webpack_require__(48378);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/shared/blogPost/sideWidget/mobile/share/Share.tsx



const Share = ({ shareList  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: shareList?.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: `cursor-pointer  ${(styles_module_default())[el.name]}`,
                onClick: ()=>{
                    window.open(el.link, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");
                    return false;
                },
                children: el.icon
            }, index))
    });
};
/* harmony default export */ var share_Share = (Share);

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/icons/Facebook.tsx
var Facebook = __webpack_require__(97943);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/icons/Twitter.tsx
var Twitter = __webpack_require__(22371);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/icons/pinterest.tsx
var pinterest = __webpack_require__(43808);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx









function Mobile() {
    const { asPath  } = (0,router.useRouter)();
    const { blogPost , domain  } = (0,useDomainContext/* useDomainContext */.w)();
    const shareList = [
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Facebook/* default */.Z, {}),
            link: `https://www.facebook.com/sharer/sharer.php?u=https://${domain.name}${asPath}`,
            name: "facebook"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Twitter/* default */.Z, {}),
            link: `https://twitter.com/share?url=https://${domain.name}${asPath}`,
            name: "twitter"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(pinterest/* default */.Z, {}),
            link: `http://pinterest.com/pin/create/button/?url=https://${domain.name}${asPath}`,
            name: "pinterest"
        }, 
    ];
    const myList = [
        {
            title: "Contents",
            slug: "contents",
            content: (0,sharedUtils/* getMainTitlesNavigationFromBody */._H)(blogPost?.model.body)
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `   px-5 py-10  max-h-[80vh] flex flex-col justify-between `,
        children: [
            myList?.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(oneElement/* default */.Z, {
                    content: el.content
                }, index)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: `mt-4 text-sm font-bold`,
                        children: "Share"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: `flex  gap-2 mt-3 justify-center  `,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(share_Share, {
                            shareList: shareList
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 36895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OneElement; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25086);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useModalContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67379);



function OneElement({ content  }) {
    const { setModal  } = (0,_hooks_useModalContext__WEBPACK_IMPORTED_MODULE_1__/* .useModal */ .d)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (content?.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().linksList)}      `,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "text-lg mt-8 mb-5 hidden lg:block ",
                    children: "Contents"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "max-h-[300px] overflow-y-auto",
                    children: content?.map((el, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: `
                                ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().bulletedListItem)} pl-5    
                                     pb-5  `,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: el?.link ?? "#",
                                dangerouslySetInnerHTML: {
                                    __html: el?.title
                                },
                                onClick: ()=>setModal({
                                        active: false,
                                        content: undefined
                                    }),
                                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().linkColor)}   block  cursor-pointer text-sm `
                            })
                        }, index))
                })
            ]
        })
    });
}


/***/ }),

/***/ 44984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Section; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/page-builder/section/styles.module.scss
var styles_module = __webpack_require__(25072);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/page-builder/utils.ts
var utils = __webpack_require__(79961);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./src/page-builder/utils/fieldAdapters.ts
/**
 * Field Adapters for Taxonomy Custom Fields
 *
 * Transforms custom field data to match what each component expects.
 * Only transforms if the data is NOT already in the correct format.
 */ // ============================================================================
// TYPE GUARDS - Check if data is already correct for component
// ============================================================================
// All possible keys that a FeatureListItem can have
const FEATURE_LIST_ITEM_KEYS = [
    "title",
    "description",
    "showList",
    "list",
    "note",
    "href",
    "image",
    "button", 
];
/**
 * Checks if value is already in FeatureList format.
 * Returns true if the object has at least one FeatureListItem property.
 */ function isFeatureListItem(value) {
    if (typeof value !== "object" || value === null) {
        return false;
    }
    // Check if object has at least one FeatureListItem key
    return FEATURE_LIST_ITEM_KEYS.some((key)=>key in value);
}
/**
 * Checks if value is already an array of FeatureList items
 */ function isFeatureListArray(value) {
    return Array.isArray(value) && value.length > 0 && isFeatureListItem(value[0]);
}
// ============================================================================
// ADAPTERS - Transform data to correct format for component
// ============================================================================
/**
 * Adapts data to FeatureList item format.
 * If already correct format, returns as-is.
 * If array of objects with 'label', transforms to { title: label }
 */ function adaptForFeatureList(value) {
    // Already correct format - return as-is
    if (isFeatureListArray(value)) {
        return value;
    }
    // Array of objects - try to transform
    if (Array.isArray(value) && value.length > 0) {
        return value.map((item)=>{
            // If item has 'label', use it as title
            if (typeof item === "object" && item !== null && "label" in item) {
                return {
                    title: item.label
                };
            }
            // If item is a string, use it as title
            if (typeof item === "string") {
                return {
                    title: item
                };
            }
            // Return item as-is
            return item;
        });
    }
    // Unknown format - return empty array
    return [];
}
function adaptForStandAloneImageTagLabel(value) {
    // If value is already a string, return as-is
    if (typeof value === "string") {
        return value;
    }
    // If value is an object with 'label', return that
    if (typeof value === "object" && value !== null && "label" in value) {
        return String(value.label);
    }
    // Otherwise, return empty string
    return "";
}
// ============================================================================
// MAIN ADAPTER - Switch based on component ID and prop key
// ============================================================================
/**
 * Adapts custom field data based on which component will consume it.
 * Only transforms if data is NOT already in correct format.
 * Returns data unchanged for components not in switch.
 */ function adaptForComponent(componentId, propKey, value) {
    // Check both component AND prop to determine if transformation is needed
    switch(`${componentId}.${propKey}`){
        case "FeatureList.items":
            // Only transform the 'items' prop for FeatureList
            return adaptForFeatureList(value);
        case "StandAloneImage.tagLabel":
            return adaptForStandAloneImageTagLabel(value);
        // Add more component.prop combinations here as needed:
        default:
            // No matching component.prop - return data unchanged
            return value;
    }
}

;// CONCATENATED MODULE: ./src/page-builder/utils/resolveDataSource.ts

function tryParseJson(value) {
    try {
        return JSON.parse(value);
    } catch  {
        return value;
    }
}
function isDataSourceWrapper(value) {
    return typeof value === "object" && value !== null && "__dataSource" in value;
}
function resolveCustomField(config, post, componentId, propKey, domainInfo) {
    const postTaxonomies = post?.taxonomyFieldGroups || [];
    const categoryTaxonomies = domainInfo?.categories?.flatMap((cat)=>cat?.taxonomyFieldGroups) || [];
    const offerTaxonomies = domainInfo?.defaultOffers?.flatMap((offer)=>offer?.taxonomyFieldGroups) || [];
    const taxonomies = [
        ...postTaxonomies,
        ...categoryTaxonomies,
        ...offerTaxonomies, 
    ];
    if (!config || !taxonomies) return null;
    const fieldCode = config.fieldCode?.value;
    const fieldTaxonomyId = config?.taxonomyId;
    if (!fieldCode) return null;
    for (const taxonomy of taxonomies){
        const field = taxonomy?.customFields?.find((f)=>f.fieldCodeName === fieldCode && f.taxonomyId === fieldTaxonomyId);
        if (field) {
            const parsed = tryParseJson(field?.fieldValue);
            // Adapt based on component AND prop - returns unchanged if not matched
            return adaptForComponent(componentId, propKey, parsed);
        }
    }
    return null;
}
function formatPostField(fieldKey, value) {
    if (fieldKey === "title") {
        return `<h1>${value}</h1>`;
    }
    return value;
}
function resolvePostField(fieldKey, post) {
    if (!fieldKey || !post) return null;
    // Support dot-notation for nested keys e.g. 'category.name', 'url.url'
    const result = fieldKey.split(".").reduce((obj, key)=>obj !== null && typeof obj === "object" ? obj[key] : null, post);
    return result != null ? tryParseJson(formatPostField(fieldKey, String(result))) : null;
}
/**
 * Resolves a single prop value that may contain a __dataSource wrapper.
 * Returns the resolved value for use in rendering.
 *
 * Handles:
 *   - Plain values (strings, numbers, booleans, objects) — returned as-is
 *   - { __dataSource: { type, static, customField, postField } } — resolved by type
 */ function resolveDataSourceValue(propValue, post, componentId, propKey, domainInfo) {
    if (!isDataSourceWrapper(propValue)) return propValue;
    const ds = propValue.__dataSource;
    switch(ds.type){
        case "static":
            return ds.static ?? null;
        case "customField":
            return resolveCustomField(ds.customField, post, componentId ?? "", propKey ?? "", domainInfo);
        case "postField":
            return resolvePostField(ds.postField?.fieldKey, post);
        default:
            return null;
    }
}
/**
 * Walks all props for a component and resolves any data source values.
 * Non-data-source props are returned unchanged.
 */ function resolveComponentProps(props, post, componentId, domainInfo) {
    const resolved = {};
    for (const [key, value] of Object.entries(props)){
        resolved[key] = resolveDataSourceValue(value, post, componentId, key, domainInfo);
    }
    return resolved;
}

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/page-builder/components/helpers/MainSectionBgPreload/index.tsx





function MainSectionBgPreload({ variables ={}  }) {
    const { visitDetails  } = (0,useDomainContext/* useDomainContext */.w)();
    let src = "";
    const bg = variables.backgroundImage;
    if (typeof bg === "string") {
        src = bg;
    } else {
        if (visitDetails.platform === "mobile" || visitDetails.platform === "wearable") {
            src = bg?.sm ?? "";
        } else if (visitDetails.platform === "tablet") {
            src = bg?.md ?? bg?.sm ?? "";
        } else {
            src = bg?.lg ?? bg?.xl ?? bg?.md ?? bg?.sm ?? "";
        }
    }
    const imageUrl = src ? (0,utils/* extractUrl */.CA)(src) : "";
    if (!imageUrl) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
            rel: "preload",
            as: "image",
            href: imageUrl
        })
    });
}

;// CONCATENATED MODULE: ./src/page-builder/section/index.tsx








const Form = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(449), __webpack_require__.e(69629), __webpack_require__.e(71132)]).then(__webpack_require__.bind(__webpack_require__, 7665)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(7665)
            ]
    }
});
const FeatureList = dynamic_default()(()=>__webpack_require__.e(/* import() */ 74221).then(__webpack_require__.bind(__webpack_require__, 74221)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(74221)
            ]
    }
});
const AffiliateOfferList = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(449), __webpack_require__.e(69629), __webpack_require__.e(99252)]).then(__webpack_require__.bind(__webpack_require__, 69629)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69629)
            ]
    }
});
const TextBlock = dynamic_default()(()=>__webpack_require__.e(/* import() */ 34223).then(__webpack_require__.bind(__webpack_require__, 34223)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(34223)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const CcpaPrivacyNotice = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(66699), __webpack_require__.e(52892)]).then(__webpack_require__.bind(__webpack_require__, 66699)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(66699)
            ]
    }
});
const Blog = dynamic_default()(()=>__webpack_require__.e(/* import() */ 96874).then(__webpack_require__.bind(__webpack_require__, 96874)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(96874)
            ]
    }
});
const ContactUs = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(5118), __webpack_require__.e(198), __webpack_require__.e(31750), __webpack_require__.e(85030), __webpack_require__.e(65817)]).then(__webpack_require__.bind(__webpack_require__, 63895)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(63895)
            ]
    },
    ssr: false
});
const ScrollToTop = dynamic_default()(()=>__webpack_require__.e(/* import() */ 26071).then(__webpack_require__.bind(__webpack_require__, 26071)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(26071)
            ]
    },
    ssr: false
});
const ContentWithImage = dynamic_default()(()=>__webpack_require__.e(/* import() */ 90106).then(__webpack_require__.bind(__webpack_require__, 90106)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(90106)
            ]
    }
});
const Claims = dynamic_default()(()=>__webpack_require__.e(/* import() */ 95661).then(__webpack_require__.bind(__webpack_require__, 95661)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(95661)
            ]
    },
    ssr: false
});
const Faq = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84731).then(__webpack_require__.bind(__webpack_require__, 84731)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(84731)
            ]
    },
    ssr: false
});
const Accordion = dynamic_default()(()=>__webpack_require__.e(/* import() */ 54140).then(__webpack_require__.bind(__webpack_require__, 54140)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(54140)
            ]
    },
    ssr: false
});
const FeatureListWithImage = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69399).then(__webpack_require__.bind(__webpack_require__, 69399)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69399)
            ]
    }
});
const StandAloneImage = dynamic_default()(()=>__webpack_require__.e(/* import() */ 24448).then(__webpack_require__.bind(__webpack_require__, 24448)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(24448)
            ]
    }
});
const LookupsList = dynamic_default()(()=>__webpack_require__.e(/* import() */ 74092).then(__webpack_require__.bind(__webpack_require__, 74092)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(74092)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
const CategoryList = dynamic_default()(()=>__webpack_require__.e(/* import() */ 27140).then(__webpack_require__.bind(__webpack_require__, 27140)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(27140)
            ]
    }
});
const ThankYou = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(3294), __webpack_require__.e(15818), __webpack_require__.e(82580)]).then(__webpack_require__.bind(__webpack_require__, 7697)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(7697)
            ]
    }
});
const Button = dynamic_default()(()=>__webpack_require__.e(/* import() */ 52940).then(__webpack_require__.bind(__webpack_require__, 52940)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(52940)
            ]
    }
});
const ButtonCategoriesListModal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 78160).then(__webpack_require__.bind(__webpack_require__, 16864)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(16864)
            ]
    }
});
const UsStatesMap = dynamic_default()(()=>__webpack_require__.e(/* import() */ 43097).then(__webpack_require__.bind(__webpack_require__, 43097)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(43097)
            ]
    }
});
const Carousel = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(89382), __webpack_require__.e(91745)]).then(__webpack_require__.bind(__webpack_require__, 91745)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(91745)
            ]
    }
});
const StatesPins = dynamic_default()(()=>__webpack_require__.e(/* import() */ 31499).then(__webpack_require__.bind(__webpack_require__, 35884)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(35884)
            ]
    }
});
const CrossSellingDomains = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69445).then(__webpack_require__.bind(__webpack_require__, 69445)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69445)
            ]
    }
});
const ContactUsForm = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(5118), __webpack_require__.e(198), __webpack_require__.e(31750), __webpack_require__.e(34151)]).then(__webpack_require__.bind(__webpack_require__, 18860)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18860)
            ]
    }
});
const FeaturedServiceAreas = dynamic_default()(()=>__webpack_require__.e(/* import() */ 47427).then(__webpack_require__.bind(__webpack_require__, 47427)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(47427)
            ]
    }
});
const TableOfContents = dynamic_default()(()=>__webpack_require__.e(/* import() */ 25772).then(__webpack_require__.bind(__webpack_require__, 25772)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(25772)
            ]
    }
});
const Tabs = dynamic_default()(()=>__webpack_require__.e(/* import() */ 17775).then(__webpack_require__.bind(__webpack_require__, 17775)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(17775)
            ]
    }
});
const InteractiveImage = dynamic_default()(()=>__webpack_require__.e(/* import() */ 34271).then(__webpack_require__.bind(__webpack_require__, 34271)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(34271)
            ]
    }
});
const PostsGrid = dynamic_default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 55278)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(55278)
            ]
    }
});
const Table = dynamic_default()(()=>__webpack_require__.e(/* import() */ 29848).then(__webpack_require__.bind(__webpack_require__, 29848)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(29848)
            ]
    }
});
const availableComponents = {
    Form,
    FeatureList,
    AffiliateOfferList,
    TextBlock,
    PrivacyPolicy,
    TermsAndConditions,
    CcpaPrivacyNotice,
    Blog,
    ContactUs,
    ScrollToTop,
    ContentWithImage,
    Claims,
    Faq,
    FeatureListWithImage,
    StandAloneImage,
    LookupsList,
    CategoryList,
    ThankYou,
    Button,
    ButtonCategoriesListModal,
    Accordion,
    UsStatesMap,
    Carousel,
    StatesPins,
    CrossSellingDomains,
    ContactUsForm,
    FeaturedServiceAreas,
    TableOfContents,
    Tabs,
    InteractiveImage,
    PostsGrid,
    Table
};
// ─── Grouping helpers ────────────────────────────────────────────────────────
/** Returns the active column groups when grouping is enabled, otherwise an empty array. */ function getActiveGroups(props) {
    return props?.enableGroups && props.groups?.length ? props.groups : [];
}
/** Extracts the `columnGroup` name from a component's props, or undefined if absent. */ function getColumnGroupName(component) {
    const groupName = component.props?.columnGroup;
    return typeof groupName === "string" ? groupName : undefined;
}
/**
 * Distributes rendered component nodes into named group buckets.
 * Components without a matching group name fall into `ungrouped`.
 */ function bucketComponentsByGroup(components, validGroupNames, renderFn) {
    const buckets = new Map();
    const ungrouped = [];
    components.forEach((component, index)=>{
        const groupName = getColumnGroupName(component);
        const node = renderFn(component, index);
        if (groupName && validGroupNames.has(groupName)) {
            const bucket = buckets.get(groupName) ?? [];
            bucket.push(node);
            buckets.set(groupName, bucket);
        } else {
            ungrouped.push(node);
        }
    });
    return {
        buckets,
        ungrouped
    };
}
// ─────────────────────────────────────────────────────────────────────────────
function Section({ variables ={} , components , props ={} , sectionIndex , classIdentifier  }) {
    const { apiCallLoading , angiWidgetDetails , pageBuilderBlogPost , domain  } = (0,useDomainContext/* useDomainContext */.w)();
    const hasFormOrClaims = components.some((i)=>i.id === "Form" || i.id === "Claims");
    // Filter components dynamically based on angiWidget status
    // This will recalculate whenever angiWidgetDetails.showWidget changes
    // angiWidgetDetails.showWidget === undefined case is needed to avoid hiding offers on initial render before angiWidgetDetails is set)
    const filteredComponents = components.filter((component)=>{
        // Hide AffiliateOfferList if it has thankYou zone and widget is undefined or true
        if (component.id === "AffiliateOfferList" && component.props?.zone === "thankYou" && component.props?.thumbtackFormat === true && (angiWidgetDetails.showWidget === undefined || angiWidgetDetails.showWidget === true)) {
            return false;
        }
        return true;
    });
    // If section only had one component and it was filtered out, don't render the section at all
    if (components.length === 1 && filteredComponents.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    const renderComponent = (component, componentIndex)=>{
        const ResolvedComponent = availableComponents[component.id];
        if (!ResolvedComponent) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                ...(0,utils/* convertToBreakpointVariables */.Xz)({
                    ...component.variables
                }, component.id === "Tabs" ? "tabs" : undefined)
            },
            className: `${(styles_module_default()).component} ${component.classIdentifier ? component.classIdentifier : ""}`,
            id: `${component.id}-${componentIndex}-${sectionIndex}`,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResolvedComponent, {
                props: resolveComponentProps(component.props || {}, pageBuilderBlogPost, component.id, domain)
            })
        }, componentIndex);
    };
    // Grouping places components into named column groups within the section grid.
    // Groups are only active when `enableGroups` is set and at least one group is defined.
    const activeGroups = getActiveGroups(props);
    let renderedChildren;
    if (activeGroups.length === 0) {
        renderedChildren = filteredComponents.map((component, index)=>renderComponent(component, index));
    } else {
        const validGroupNames = new Set(activeGroups.map((g)=>g.name));
        const { buckets , ungrouped  } = bucketComponentsByGroup(filteredComponents, validGroupNames, renderComponent);
        const columns = activeGroups.filter((group)=>buckets.has(group.name)).map((group)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).columnGroup,
                style: (0,utils/* convertToBreakpointVariables */.Xz)({
                    groupColumnStart: group.columnStart,
                    groupColumnSpan: group.columnSpan,
                    groupGap: group.gap
                }),
                children: buckets.get(group.name)
            }, `group-${group.name}`));
        renderedChildren = [
            ...columns,
            ...ungrouped
        ];
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        style: {
            ...(0,utils/* convertToBreakpointVariables */.Xz)(variables),
            "--formBackground-sm": hasFormOrClaims ? "var(--global-form-general-containing-section-background-color)" : undefined
        },
        className: `${(styles_module_default()).section} ${classIdentifier ? classIdentifier : ""} ${apiCallLoading && hasFormOrClaims ? (styles_module_default()).sectionOverlay : ""}`,
        id: `section-${sectionIndex}`,
        children: [
            sectionIndex === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(MainSectionBgPreload, {
                variables: variables
            }),
            renderedChildren
        ]
    });
}


/***/ }),

/***/ 48378:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"facebook":"styles_facebook__EYfOu","twitter":"styles_twitter__47r59","pintrest":"styles_pintrest__w6OTr"};

/***/ }),

/***/ 25086:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"linkColor":"style_linkColor__aZ9m3","linksList":"style_linksList__xLuOw","bulletedListItem":"style_bulletedListItem__H1JoX"};

/***/ }),

/***/ 25072:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__76kNJ","sectionOverlay":"styles_sectionOverlay__TVB0M","component":"styles_component__PQAYC","columnGroup":"styles_columnGroup__6onux"};

/***/ })

}]);